import React, { useEffect, useState } from "react";
import Axios from 'axios';
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import { SnackbarProvider, useSnackbar } from 'notistack';
import style from "./Navios.module.css";
import { Navigate, useNavigate } from "react-router-dom";

const Navios = () => {
  const navigate = useNavigate();

  const [naviosList, setNaviosList] = useState([]);
  const [selectedNavio, setSelectedNavio] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getNavios();
  }, []);

  const getNavios = () => {
    Axios.get('https://operacao.setlogistica.com.br/api/navio').then((response) => {
      setNaviosList(response.data);
    });
  };

  const handleNavioSelect = (e) => {
    const selectedId = e.target.value;
    const navio = naviosList.find((n) => n.COD_NAVIO === parseInt(selectedId));
    setSelectedNavio(navio || null);
  };

  const validaOp = () => {
    if (selectedNavio?.STATUS === 'OPERANDO') {
      showAlert('Navio já está em operação!', 'error');
    } else {
      navigate(`/operacao/cadastro/${selectedNavio.NOME_NAVIO}/${selectedNavio.COD_NAVIO}`);
    }
  };

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  return (
    <>
      <Navbar />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.navItem} onClick={() => navigate("/navios/cadastro")}>
             Cadastrar Navios 
            </div>
            <div className={style.navItemActive}>
              {'>'}  Navios
            </div>
          </div>


          <div className={style.selectWrapper}>
            <select className={style.navioSelect} onChange={handleNavioSelect} defaultValue="">
              <option value="" disabled>Escolha um navio...</option>
              {naviosList.map((navio) => (
                <option key={navio.COD_NAVIO} value={navio.COD_NAVIO}>
                  {navio.NOME_NAVIO}
                </option>
              ))}
            </select>
          </div>

          {selectedNavio && (
            <div className={style.details}>
              <div className={style.detailGrid}>
                <div className={style.detailItem}>
                  <i className="fa fa-ship icon"></i>
                  <span><b>Nome:</b> {selectedNavio.NOME_NAVIO || "-"}</span>
                </div>
                <div className={style.detailItem}>
                  <i className="fa fa-id-badge icon"></i>
                  <span><b>IMO:</b> {selectedNavio.IMO_NAVIO || "-"}</span>
                </div>
                <div className={style.detailItem}>
                  <i className="fa fa-flag icon"></i>
                  <span><b>Bandeira:</b> {selectedNavio.BANDEIRA || "-"}</span>
                </div>
                <div className={style.detailItem}>
                  <i className="fa fa-circle icon"></i>
                  <span><b>Status:</b> {selectedNavio.STATUS || "-"}</span>
                </div>
              </div>
              <button className={style.startButton} onClick={validaOp}>INICIAR NOVA VIAGEM</button>
            </div>
          )}

        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider anchorOrigin={{ vertical: "bottom", horizontal: "right" }} maxSnack={3} autoHideDuration={2500}>
      <Navios />
    </SnackbarProvider>
  );
};
